import { ReactNode } from "react";
import styles from "./SettingsToolbar.module.css";

/**
 * Shared flex wrapper for settings-page toolbars (search/add bars): a single
 * input/search field that fills the remaining width, plus one or more
 * buttons/dropdowns that size to their own content. All children share a
 * consistent height (via `--settings-toolbar-height`) and an 8px gap.
 *
 * Apply `settingsToolbarFieldClassName` to the main input's wrapper class
 * (e.g. `CoreSearchField`'s `searchFieldWrapperClassname`, or a `CoreTextField`/
 * `CoreTextBox`'s `className`) so it grows to fill the row, and
 * `settingsToolbarButtonClassName` to each `CoreButton` so it sizes to its
 * content with consistent padding/height/radius.
 */
export function SettingsToolbar({ children, className }: { children: ReactNode; className?: string }) {
	return <div className={className ? `${styles.toolbar} ${className}` : styles.toolbar}>{children}</div>;
}

export const settingsToolbarFieldClassName = styles.toolbarField;
export const settingsToolbarButtonClassName = styles.toolbarButton;
